module.exports = __webpack_public_path__ + "media/images/photos/21-104accf818368f7fab0b2ab69dd0358f.jpg";